// src/api/bookmarksApi.js
//
// Saved Resources / Recommended For You API calls, matching pyqApi.js's
// convention (askosAuthHeader() passed explicitly per call).
import api from './api';
import { askosAuthHeader } from '../askos/askosApi';

export const listBookmarks = (slug) =>
  api.get(`/tenant/${slug}/askos/bookmarks`, { headers: askosAuthHeader() }).then(r => r.data);

export const createBookmark = (slug, target) =>
  api.post(`/tenant/${slug}/askos/bookmarks`, target, { headers: askosAuthHeader() }).then(r => r.data);

export const deleteBookmark = (slug, bookmarkId) =>
  api.delete(`/tenant/${slug}/askos/bookmarks/${bookmarkId}`, { headers: askosAuthHeader() }).then(r => r.data);

export const listResources = (slug, params = {}) =>
  api.get(`/tenant/${slug}/askos/resources`, { headers: askosAuthHeader(), params }).then(r => r.data);

export const getRecommendations = (slug) =>
  api.get(`/tenant/${slug}/askos/recommendations`, { headers: askosAuthHeader() }).then(r => r.data);
